import { flushSync } from 'react-dom';

/** Nome da transição do passo (lume.css): próprio, para não disputar o `uyzy-drill` do menu do celular. */
export const FLOW_STEP_TRANSITION = 'uyzy-flow-step';

/**
 * Troca de passo com o par `drill` (U38, MOVIMENTO.md): o passo novo vem 32 px do lado para onde se
 * anda e o antigo sai para o outro; voltar inverte (`data-drill`). Sem View Transitions ou com
 * `prefers-reduced-motion`, a troca é seca.
 */
export function withFlowTransition(direction: 'forward' | 'back', update: () => void): void {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || typeof document.startViewTransition !== 'function') {
    update();
    return;
  }
  const root = document.documentElement;
  // `data-drill` tira o nome da página e dá o sentido (lume.css): só o passo anima, a casca fica parada.
  root.dataset['drill'] = direction;
  const transition = document.startViewTransition(() => flushSync(update));
  void transition.finished
    .catch(() => undefined)
    .finally(() => {
      delete root.dataset['drill'];
    });
}
